import Exec from '@/components/exec';
import { Divider, Typography } from '@mui/material';
import styled from 'styled-components';

const MainWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow:hidden;
  .head{
    padding: 0.5rem;
    width: 100%;
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background:rgba(82, 133, 164, 0.87);
    color: #ffffff;
  }
`;

export default function ExecTemplate() {
  return (
    <MainWrap>
      <div className="head">
        <Typography variant="h5">배차</Typography>
      </div>
      <div style={{ width: '100%' }}>
        <Divider variant="fullWidth" />
      </div>
      <Exec />
    </MainWrap>
  );
}
